﻿export default class Carousel {

    carouselSelector = '[data-js-carousel]';
    itemClassName = 'carousel__item';
    itemSelector = '[data-js-content]';
    totalSelector = '[data-js-total]';
    buttonNextSelector = '[data-js-next]';
    buttonPrevSelector = '[data-js-prev]';

    slide = 0;
    moving = true;
  
    constructor() {
        this.initCarousel();
    }

    setInitialClasses = () => {
        const carousels = getElementList(document, this.carouselSelector);

        if (carousels) {
            carousels.forEach((carousel) => {
                let items = getElementList(carousel, this.itemSelector);
                let totalItems = items.length;
                const total = carousel.querySelector(this.totalSelector);

                if (total) {
                    total.textContent = `${this.slide + 1} / ${totalItems}`;
                }

                if (totalItems >= 1) {

                    if (totalItems >= 3) {
                        items[totalItems - 1].classList.add('prev');
                        items[0].classList.add('active');
                        items[1].classList.add('next');

                    }

                    if (totalItems === 1) {
                        items[0].classList.add('active');
                    }

                    else {
                        items[0].classList.add('active');
                        items[1].classList.add('next');
                    }               
                }

                if (totalItems > 1) {
                    this.setEventListeners(carousel, items, totalItems);
                }
            })         
        }
    }


    addWAI = (carousel) => {
        const liveregion = document.createElement('div');

        liveregion.setAttribute('aria-live', 'polite');
        liveregion.setAttribute('aria-atomic', 'true');
        liveregion.setAttribute('class', 'liveregion sr-only');

        carousel.appendChild(liveregion);
    }


    setEventListeners = (carousel, items, totalItems) => {
        if (carousel) {
            const next = carousel.querySelector(this.buttonNextSelector);
            const prev = carousel.querySelector(this.buttonPrevSelector);

            next.addEventListener('click', () => {
                this.moveNext(carousel, items, totalItems)
            });
            prev.addEventListener('click', () => {
                this.movePrev(carousel, items, totalItems);
            });

            this.addWAI(carousel, items, totalItems);
        }
     }

    moveNext = (carousel, items, totalItems) => {
        if (!this.moving) {
            if (this.slide === 0) {
                this.slide = (totalItems - 1)
            } else {
                this.slide--;
            }
        }
        this.moveCarouselTo(carousel, items, totalItems);
    }

    movePrev = (carousel, items, totalItems) => {
        if (!this.moving) {
            if (this.slide === (totalItems - 1)) {
                this.slide = 0;
            } else {
                this.slide++;
            }
        }
        this.moveCarouselTo(carousel, items, totalItems);
    }

    disableInteraction = () => {
        this.moving = true;

        setTimeout(() => {
            this.moving = false;
        }, 500)
    }

    moveCarouselTo = (carousel, items, totalItems) => {
        if (!this.moving) {

            this.disableInteraction();

            if (carousel) {
                let newPrevious = this.slide - 1,
                    newNext = this.slide + 1,
                    oldPrevious = this.slide - 2,
                    oldNext = this.slide + 2;

                if ((totalItems - 1) > 3) {
                    if (newPrevious <= 0) {
                        oldPrevious = (totalItems - 1);
                    } else if (newNext >= (totalItems - 1)) {
                        oldNext = 0;
                    }
                }

                if (this.slide === 0) {
                    newPrevious = (totalItems - 1);
                    oldPrevious = (totalItems - 2);
                    oldNext = (this.slide + 1);

                } else if (this.slide === (totalItems - 1)) {
                    newPrevious = (this.slide - 1);
                    newNext = 0;
                    oldNext = 1;
                }


                items[newPrevious].className = this.itemClassName + ' prev';
                items[this.slide].className = this.itemClassName + ' active';
                items[newNext].className = this.itemClassName + ' next';

                const liveregion = carousel.querySelector('.liveregion');
                liveregion.textContent = 'Item ' + (this.slide + 1) + ' of ' + totalItems;

                const total = carousel.querySelector(this.totalSelector);

                if (total) {
                    total.textContent = `${this.slide + 1} / ${totalItems}`;
                }
            }
        }   
    }

    initCarousel = () => {
        this.setInitialClasses();
        this.setEventListeners();

        this.moving = false;

    }
}

function getElementList(parent, query) {
    const elements = parent.querySelectorAll(query);
    return Array.from(elements);
}